import { Pipe, PipeTransform, inject } from '@angular/core';
import { HisBaseGlobalsService } from '../service/base/his-base-globals.service';

@Pipe( {
    name: 'hisUpperCaseFirstLetter',
    standalone: false
} )
export class HisUppercasefirstletterPipe implements PipeTransform {
    private hisBaseGlobalsService = inject(HisBaseGlobalsService);


    transform( text: string ): string {
        if (text && this.hisBaseGlobalsService.getLanguage().toLowerCase() !== 'de' ) {
            return text.substring( 0, 1 ).toUpperCase() + text.substring( 1 );
        }
        else {
            return text;
        }
    }
}
